import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, IconButton, Link } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Audit from '../../interfaces/audit';
import Case from '../../interfaces/case';
import apiClient from '../../axiosClient';
import SearchResultGrid from '../searchResultGrid/searchResultGrid';
import auditColumnDef from '../../colDef/auditColumnDef';
import modalStyle from '../../styles/modalStyle';

interface AuditModalProps {
    open: boolean;
    selectedRow: Case;
    onClose: () => void;
}

/**
 * This modal is being used for Audit
 */
const AuditDataModal: React.FC<AuditModalProps> = ({ open, onClose, selectedRow }) => {
    const [additionalData, setAdditionalData] = useState<Audit[]>([]);

    // Make API call to fetch dropdown keys on component load
    const fetchAdditionalData = async () => {
        let api = "/api/v1/audit?client_reference_id=" + selectedRow.client_reference_id;
        try {
            const response = await apiClient.get(api);
            if (response.status === 200) {
                let additionalData: Audit[] =[];
                additionalData = Audit.initialiseAudit(response.data);
                
                setAdditionalData(additionalData);
            } else {
                alert("Error while loading audit : "  + ", Error: " + response.data.message);
            }
        } catch (error: any) {
            if (error.response) {
                alert('Error response data:' + error.response.data.message);
            } else if (error.request) {
                alert('No response received:' + error.request);
            } else {
                alert('Error message:' + error.message);
            }
        }
    };

    useEffect(() => {
        fetchAdditionalData();
    }, []);

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography id="modal-title" variant="h6">
                        Audit
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box mt={3}>
                    <Typography variant="subtitle1">Selected Rows:</Typography>
                    <SearchResultGrid
                        sortModel={[{field: 'created_date', sort: 'asc'}]}
                        getRowId={(row) =>row.audit_id}
                        results={additionalData}
                        onSelectRow={() => { }}
                        columns={auditColumnDef }
                    />
                </Box>
            </Box>
        </Modal>
    );
};

export default AuditDataModal;
